import { useState } from "react";



const UndoImage: React.FunctionComponent<{ imageValue: any, onUndoImage: any }> = (props) => {

    const [isChangeUndo, setIsChangeUndo] = useState<boolean>(false);


    const UndoHandle = () => {
        console.log('Undoing image:', props.imageValue);
           console.log('Redoing image:', props.imageValue);
        if (!props.imageValue || !props.imageValue.id) {
            console.error('No image selected for redo');
            return;
        }
        setIsChangeUndo(true)
        props.onUndoImage(props.imageValue.id).then(() => {
            setIsChangeUndo(false);
        })
            .catch(() => {
                setIsChangeUndo(false);
            });
    }

    return (
        <button
            className={`button-reset  back-trans border-black padd-10 marg-right-16 ${props.imageValue && props.imageValue.currentState !== undefined && props.imageValue.currentState === 0 ? "disabled" : ""} `}
            onClick={UndoHandle}
        >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_504_397)">
                    <path d="M9 14L5 10L9 6" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M5 10H16C17.0609 10 18.0783 10.4214 18.8284 11.1716C19.5786 11.9217 20 12.9391 20 14C20 15.0609 19.5786 16.0783 18.8284 16.8284C18.0783 17.5786 17.0609 18 16 18H15" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </g>
                <defs>
                    <clipPath id="clip0_504_397">
                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)" />
                    </clipPath>
                </defs>
            </svg>
            {isChangeUndo && <div className="col-auto marg-left-5">
                <div className="spinner-border text-primary" style={{ width: "20px", height: "20px" }} role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>}
        </button>
    )

}
export default UndoImage;